import { makeStyles } from "@material-ui/core";
import { assetsUrl } from "../../../common/config";

export const useStyle = makeStyles((theme) => ({
  freeBar: () => ({
    backgroundColor: "#0344DC",
    backgroundImage: `url('${assetsUrl}/resourcesBar.png')`,
    backgroundRepeat: "no-repeat",
    backgroundPositionY: "center",
    backgroundBlendMode: "color-burn",
    backgroundSize: "auto 100%",
    [theme.breakpoints.down("xs")]: {
      padding: "12px",
      cursor: "pointer",
      height: "76px",
    },

    "& .MuiTypography-root": {
      color: "white",
      [theme.breakpoints.down("xs")]: {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    "& .MuiButton-endIcon": {
      [theme.breakpoints.down("sm")]: {
        margin: 0,
      },
    },
    "& .MuiButton-root": {
      backgroundColor: "transparent",
      border: "1px solid #FFF",
      borderRadius: "100px",
      padding: "8px 30px",
      color: "white",
      textTransform: "none",
      [theme.breakpoints.down("sm")]: {
        border: "none",
      },
      [theme.breakpoints.down("xs")]: {
        marginTop: "5px",
        fontSize: "0.8rem",
        padding: "4px 15px",
      },

      "& .MuiSvgIcon-root": {
        color: "#59D7ED",
      },
    },
    "& .MuiButton-root:hover": {
      backgroundColor: "#F5F8FF",
      color: "#0344DC",
    },
  }),
  text: {
    fontFamily: "Lato",
    lineHeight: "19.2px",
  },
  hideOnSm: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));
